import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ApolloClient, ApolloLink, InMemoryCache, ApolloProvider, createHttpLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { AuthProvider } from "./contexts/AuthContext";

const serverUrl = process.env.REACT_APP_API_URL || "RUNTIME_REPLACE_REACT_APP_API_URL";
const appVersion = process.env.REACT_APP_VERSION || "RUNTIME_REPLACE_REACT_APP_VERSION";

const httpLink = createHttpLink({
  uri: serverUrl + '/graphql',
  credentials: 'include',
  headers: {
    version: appVersion,
  },
});

function carriesIdempotencyKey(value) {
  if (!value || typeof value !== "object") return false;
  if (value.idempotencyKey) return true;
  return Object.values(value).some((item) => carriesIdempotencyKey(item));
}

const retryLink = new RetryLink({
  delay: { initial: 300, max: 2000, jitter: true },
  attempts: {
    max: 3,
    retryIf: (error, operation) => {
      if (!error || error.result) return false;
      const definition = operation.query.definitions.find((item) => item.kind === "OperationDefinition");
      if (definition?.operation !== "mutation") return true;
      return carriesIdempotencyKey(operation.variables);
    },
  },
});

const client = new ApolloClient({
  link: ApolloLink.from([retryLink, httpLink]),
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
